module.exports = __webpack_public_path__ + "static/media/HQ18_nutrients@2x.3a0974b7.png";